export const regexNumberAndCommon = /^[0-9.,]*$/

/**
 * Matches all non-alphanumeric characters to support sanitizing invite code input.
 * Use with `String.replace(regexAlphaNumeric, "")`.
 */
export const regexAlphaNumeric = /[^a-zA-Z0-9]/g

/**
 * Matches a single alphanumeric character (A–Z, a–z, 0–9).
 * Use to validate individual keypress events so only permitted replacement
 * characters trigger field-clearing logic (e.g., invite code inputs).
 * Example: `regexAlphaNumericKey.test(e.key)`
 */
export const regexAlphaNumericKey = /^[A-Za-z0-9]$/

/**
 * Matches private/local IPv4 ranges only (RFC 1918 + loopback):
 * `10.x.x.x`, `172.16-31.x.x`, `192.168.x.x`, `127.x.x.x`.
 */
export const regexPrivateIP = /^(10\.\d{1,3}\.\d{1,3}\.\d{1,3}|172\.(1[6-9]|2\d|3[01])\.\d{1,3}\.\d{1,3}|192\.168\.\d{1,3}\.\d{1,3}|127\.\d{1,3}\.\d{1,3}\.\d{1,3})$/
